export class CarTemplateFilter {
    public companyId:number;
    public countryOid:number;
    public countryCode:string;
    public brand:string;
    public model:string;
    public approvalStatus:string;
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/model/car-template-filter.ts